export default __webpack_public_path__ + "static/media/avatar_01.238cc8ef.png";